<template>
  <div class="alerts">
    <b-alert v-for="(alert, index) in responsibleAlerts"
             :key="index"
             :variant="alert.variant"
             dismissible
             show>
      <div v-html="sanitize(alert.text)"></div>
    </b-alert>
  </div>
</template>

<script>
  import purify from 'dompurify';
  import AlertStore from './AlertStore';
  import WindowProvider from '../window/WindowProvider';

  export default {
    name: 'AlertComponent',
    props: {
      context: String,
    },
    data() {
      return {
        alerts: AlertStore.alerts,
      };
    },
    computed: {
      responsibleAlerts() {
        return this.alerts.filter((alert) => alert.context === this.context);
      },
    },
    created() {
      this.initExpiryCheck();
    },
    methods: {
      initExpiryCheck() {
        const interval = 1000;
        WindowProvider.setInterval(() => {
          this.alerts = AlertStore.alerts;
          this.reduceTtl();
        }, interval);
      },
      reduceTtl() {
        this.responsibleAlerts.forEach((alert) => {
          if (alert.ttl === 0) {
            AlertStore.remove(alert);
            return;
          }

          alert.ttl -= 1;
        });
      },
      sanitize(message) {
        return purify.sanitize(message);
      },
    },
  };
</script>

<style lang="scss" scoped>
    .alerts {
      position: absolute;
      left: 30%;
      top: 10px;
      width: 40%;
      z-index: $zindex-alert;
    }
</style>
